<div *ngIf="visible" class="cockpit-vehicle-header flex items-center gap-0.5 min-w-0 flex-1 sm:ml-1 md:max-w-[min(100%,28rem)]">
    <button
        type="button"
        mat-icon-button
        class="hidden sm:flex shrink-0 text-secondary"
        [disabled]="!canGoPrev"
        (click)="goPrev()"
        [attr.aria-label]="'Veículo anterior'"
    >
        <mat-icon>chevron_left</mat-icon>
    </button>

    <!-- Botão nativo: mat-button projeta mat-icon para fora do rótulo e empilha ícone + texto -->
    <button
        type="button"
        [matMenuTriggerFor]="vehicleMenu"
        class="cockpit-vehicle-header__trigger !normal-case inline-flex min-w-0 flex-1 flex-row items-center gap-1 !px-2 !py-1.5 h-auto rounded-lg border-0 bg-transparent text-left hover:bg-black/5 dark:hover:bg-white/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 disabled:cursor-not-allowed disabled:opacity-50"
        [disabled]="vehicles.length === 0"
        [attr.aria-haspopup]="vehicles.length > 0 ? 'menu' : null"
        [attr.aria-label]="'Lista de veículos da empresa'"
    >
        <div
            class="hidden sm:flex shrink-0 w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-primary/15 items-center justify-center text-primary"
            aria-hidden="true"
        >
            <mat-icon [svgIcon]="'heroicons_outline:truck'" class="cockpit-vehicle-header__amb-icon"></mat-icon>
        </div>
        <div class="flex min-w-0 flex-1 flex-col items-start text-left leading-tight">
            <span class="text-base sm:text-lg font-semibold text-primary truncate max-w-[14rem] sm:max-w-[18rem]">
                <span autoTranslate>Ambulância</span> {{ displayName }}
            </span>
            <span class="text-xs text-secondary truncate max-w-[14rem] sm:max-w-[18rem]">{{ plateLine }}</span>
            <span class="text-[11px] text-secondary truncate max-w-[14rem] sm:max-w-[18rem]">{{ groupLine }}</span>
        </div>
    </button>

    <button
        type="button"
        mat-icon-button
        class="hidden sm:flex shrink-0 text-secondary"
        [disabled]="!canGoNext"
        (click)="goNext()"
        [attr.aria-label]="'Próximo veículo'"
    >
        <mat-icon>chevron_right</mat-icon>
    </button>

    <mat-menu #vehicleMenu="matMenu" panelClass="cockpit-vehicle-menu-panel">
        <div class="cockpit-vehicle-menu__label px-3 py-1.5 text-[11px] uppercase tracking-wide text-secondary border-b border-white/10">
            <span autoTranslate>Veículos da empresa</span>
        </div>
        <button
            mat-menu-item
            *ngFor="let v of vehicles; trackBy: trackByVehicleId"
            (click)="selectVehicle(v)"
            [class.cockpit-vehicle-menu__current]="v.vehicle_id === currentVehicleId"
        >
            <div class="flex items-start gap-3 py-1 min-w-[240px] max-w-[90vw] sm:max-w-sm">
                <div
                    class="shrink-0 w-7 h-7 rounded-full bg-primary/15 flex items-center justify-center text-primary mt-0.5"
                    aria-hidden="true"
                >
                    <mat-icon [svgIcon]="'heroicons_outline:truck'" class="cockpit-vehicle-header__amb-icon cockpit-vehicle-header__amb-icon--menu"></mat-icon>
                </div>
                <div class="flex flex-col items-start min-w-0 gap-0.5">
                    <span class="text-sm font-semibold leading-tight text-gray-900 dark:text-slate-100 truncate w-full">{{
                        v.name || ('#' + v.vehicle_id)
                    }}</span>
                    <span class="text-xs text-secondary leading-tight truncate w-full">{{ v.license_plate || '—' }} · {{ v.group || '—' }}</span>
                </div>
            </div>
        </button>
    </mat-menu>
</div>
